
import Calendar from "./Calendar";
import {Localization} from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

import moment from "moment";

/**
 * Creates a calendar dropdown
 * 
 * @param {object} props
 * @returns {node}
 */
function CalenderDropdown({setDropDown, dropDown, localization, date, validDates, previousDates, nextOrderDate, onSelectDate, deliveryDates, newSeasonDistrDates}) {
    /**
     * selects the date and hides the dropdown window
     * 
     * @param {object} date
     * @returns {undefiend}
     */
    function onClick(date) {
        setDropDown(null);
        onSelectDate(date);
    }
    return (
        <Calendar localization={localization} dropDown={dropDown} date={date} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={onClick} deliveryDates={deliveryDates} newSeasonDistrDates={newSeasonDistrDates}/>         
    );
}
CalenderDropdown.propTypes = {
    setDropDown: PropTypes.func,
    date: PropTypes.string,
    dropDown: PropTypes.bool,
    nextOrderDate: PropTypes.string,
    onSelectDate: PropTypes.func,
    previousDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    validDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    localization: Localization.propTypes.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    newSeasonDistrDates: PropTypes.array.isRequired,    
};


class CalendarItem extends React.Component {
    constructor(props){
        super(props);

        this.onSelectDate = this.onSelectDate.bind(this);
    }

    onSelectDate(date) {
        const {
            deliveryDates,
            setActiveOrder,
        } = this.props;
        for(let i=0; i<deliveryDates.length; i++){
            if( moment(deliveryDates[i].deliveryDate).format("YYYY-MM-DD")==date ){
                setActiveOrder(deliveryDates[i].shipmentId, deliveryDates[i].distributionRouteId, deliveryDates[i].deliveryDate);
                this.props.history.push("/order/products");
            }
        }
    }

    render(){

        const {
            deliveryDates,
            activeOrder,
            setDropDown,
            localization,
            newSeasonDistrDates,
        } = this.props;

        const nextOrderDate = deliveryDates && deliveryDates.length>0 ? moment(deliveryDates[0].deliveryDate).format("YYYY-MM-DD") : "";
        const workingDate = moment(activeOrder.deliveryDate).format("YYYY-MM-DD");
        const previousDates = [];
        const validDates = deliveryDates ? deliveryDates.map(item => {
            return moment(item.deliveryDate).format("YYYY-MM-DD");
        }) : [];

        return (
            <div>
                <CalenderDropdown localization={localization} dropDown={true} date={workingDate} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={this.onSelectDate} setDropDown={setDropDown} deliveryDates={deliveryDates} newSeasonDistrDates={newSeasonDistrDates} />                
            </div>
        );
    }
}
CalendarItem.propTypes = {
    width: PropTypes.number,
    deliveryDates: PropTypes.array,
    setDropDown: PropTypes.func,
    activeOrder: PropTypes.object.isRequired, 
    localization: Localization.propTypes.isRequired,
    setActiveOrder: PropTypes.func,
    history: PropTypes.object.isRequired,
    newSeasonDistrDates : PropTypes.array.isRequired,
};
export default CalendarItem;